import React from 'react';
import { NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { MOCK_USER } from '../data/mockData';

const { FiHome, FiPieChart, FiSettings, FiPlayCircle, FiZap, FiGrid } = FiIcons;

const NavItem = ({ to, icon, label }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-300 ${
        isActive 
          ? 'bg-ink-700 text-aurora border border-aurora/20 shadow-[0_0_15px_rgba(110,231,183,0.05)]' 
          : 'text-gray-400 hover:text-gray-200 hover:bg-ink-700/50'
      }`
    }
  >
    <SafeIcon icon={icon} className="w-5 h-5" />
    <span className="font-medium hidden md:block">{label}</span>
  </NavLink>
);

const Navigation = () => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 md:relative md:w-64 glass-panel md:border-r md:border-t-0 border-t border-ink-600 z-50 flex flex-col justify-between h-[70px] md:h-screen">
      
      <div className="hidden md:flex items-center gap-3 p-6 mb-4">
        <div className="w-8 h-8 rounded bg-gradient-to-br from-aurora to-lilac flex items-center justify-center shadow-[0_0_10px_rgba(216,180,254,0.3)]">
          <SafeIcon icon={FiGrid} className="text-ink-900 w-5 h-5" />
        </div>
        <span className="text-xl font-bold tracking-tight text-white">Mood<span className="text-gradient">Grid</span></span>
      </div>

      <div className="flex justify-around md:flex-col md:justify-start p-2 md:p-4 gap-1 md:gap-2 w-full">
        <NavItem to="/" icon={FiHome} label="Journal" />
        <NavItem to="/insights" icon={FiPieChart} label="Insights" />
        <NavItem to="/demo" icon={FiPlayCircle} label="Demo" />
        <NavItem to="/settings" icon={FiSettings} label="Settings" />
      </div>

      <div className="hidden md:flex flex-col p-6 mt-auto border-t border-ink-700/50">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-ink-600 flex items-center justify-center border border-ink-500">
            <span className="text-sm font-semibold text-aurora">AF</span>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-200">{MOCK_USER.name}</p>
            <p className="text-xs text-gray-500 flex items-center gap-1">
              <SafeIcon icon={FiZap} className="w-3 h-3 text-aurora" /> 
              {MOCK_USER.streak} Day Streak
            </p>
          </div>
        </div>
        <p className="text-[10px] text-gray-600 font-mono text-center mt-2">Made by LingLink AI and DigLab AI</p>
      </div>
    </nav>
  );
};

export default Navigation;